<template>
    <b-row id="business_qualifications_header"
         class="business-qualifications-header">
         <b-col cols="12"
            lg="6"
            order-lg="2"
            order="0"
            id="business_qualifications_header_update"
            class="business-qualifications-header-update"
                v-if="option === 'make_update'">
            <router-link :to="{ name: update.url }" class="business-qualifications-header-update-element">
                <p class="business-qualifications-header-update-label">{{update.label}}</p>
                <p class="business-qualifications-header-update-value"
                   style="text-transform: uppercase">{{update.value}}</p>
            </router-link>
        </b-col>
        <b-col cols="12"
               lg="12"
               order-lg="3">
            <router-link :to="{ name: 'MarketingPlan' }">
                <div class="business-qualifications-header__additional-link">
                    Go to the FuturoNetwork marketing plan<br>
                    and check exactly how to achieve the next career levels
                </div>
            </router-link>
        </b-col>
        <b-col cols="6"
            lg="3"
            id="business_qualifications_header_info"
            class="business-qualifications-header-info"
            v-for="(information, index) in informations" :key="index"
            :order="index">
            <div class="business-qualifications-header-info-element">
                <p class="business-qualifications-header-info-label" v-html="information.label"></p>
                <p class="business-qualifications-header-info-value" v-bind:class="{ 'notice-available': information.notice }" v-html="information.value"></p>
                <p class="business-qualifications-header-info-notice">{{ information.notice }}</p>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    import BusinessQualificationsTurnoverTooSmall from './BusinessQualificationsTurnoverTooSmall.vue'

    export default {
        dependencies: ['money'],
        components: { BusinessQualificationsTurnoverTooSmall},
        computed: {
            option () {
                return this.$store.getters.qualifications.option
            },
            informations () {
                return {
                    0: {
                        label: 'My career level <br class="desktop-only">(from the previous month)',
                        value: this.$store.getters.user.previousCareerLevel
                    },
                    1: {
                        label: 'My career level <br class="desktop-only">(worked out this month)',
                        value: this.$store.getters.user.currentMonthCareerLevel
                    },
                    2: {
                        label: 'My monthly turnover <br class="desktop-only"><br class="desktop-only">',
                        value: 'FND '  + this.money.format(this.$store.getters.statistics.turnoverMonthly, 'fnd')
                    },
                    3: {
                        label: 'Career sponsor Bonus',
                        value: this.$store.getters.user.directBonusCareerLevel + '%'
                    },
                    4: {
                        label: 'Matching Bonus',
                        value: this.$store.getters.user.matchingBonus + '%'
                    },
                    5: {
                        label: 'Car Bonus',
                        value: 'FND '  + this.money.format(this.$store.getters.user.lastCarBonus, 'fnd'),
                        notice: '* paid monthly'
                    },
                    6: {
                        label: 'Business Bonus',
                        value: 'FND '  + this.money.format(this.$store.getters.user.lastBusinessBonus, 'fnd'),
                        notice: '* paid monthly'
                    }
                }
            }
        },
        data () {
            return {
                update: {
                    label: 'If you want to go to the next position you must make an update in your Start Packet',
                    value: 'Make an update',
                    url: 'StartPacket',
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../../../../assets/scss/_colors.scss';

    .business-qualifications-header-info{

        &-value {
            &.notice-available {
                float: left;
            }
        }

        &-notice {
            font-size: 85%;
            line-height: 22px;
        }

        .business-qualifications-header-info-element{
            padding-bottom: 20px;
            margin-bottom: 30px;
            border-bottom: 3px solid $base1;
        }
    }

    .business-qualifications-header {
        &__additional-link {
            color: $base1;
            font-weight: bold;
            margin-bottom: 30px;
        }
    }

    .business-qualifications-header-update-element{
        display: block;
        position: relative;

        .business-qualifications-header-update-label{
            position: relative;
            color: $white;
            background-color: $base2;
            width: 60%;
            padding: 10px;
            font-weight: regular;
            line-height: 1;

            &:after{
                position: absolute;
                z-index: 1;
                top: 0;
                right: -15px;
                content: '';
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 33px 0 33px 15px;
                border-color: transparent transparent transparent $base2;
                transition: 200ms all linear;
            }
        }

        .business-qualifications-header-update-value{
            position: absolute;
            color: $white;
            background-color: $base1;
            width: 40%;
            height: 100%;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            padding: 10px;
            font-weight: regular;
            line-height: 1;
            font-size: 20px;
            text-align: center;
            text-transform: uppercase;
        }
    }

    .commissions-total-label{
        padding: 30px 0;
        border-bottom: 3px solid $base1;

        p{
            color: $base1;
        }
    }

    .commissions-total-value{
        margin-bottom: 30px;

        p{
            font-size: 54px;
            color: $base1;
        }
    }

    @media(max-width:991px){
        .commissions-stats-component{
            margin: 30px -15px 30px !important;
        }
    }

    @media(max-width:991px){
        .business-qualifications-header-update{
            margin: 30px 0;

            .business-qualifications-header-update-label,
            .business-qualifications-header-update-value{
                height: 86px;
                line-height: 1.15;
                display: flex;
                align-items: center;
                justify-content: center;
            }


            .business-qualifications-header-update-label{
                &:after{
                    border-width: 43px 0 43px 15px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/business-qualifications/BusinessQualificationsHeader.vue